import util from "../util";

const doGet = (context, url, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.get(url, {headers}).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });
  })
}


const doPost = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.post(url, body, {headers}).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });
  })
}


const doPostDonwload = (context, url, body, nameFile, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.post(url, body, {headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${nameFile}.${body.extExport}`);
      document.body.appendChild(link);
      link.click();
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, "Ocurrió un error al descargar el archivo")

        var reader = new FileReader();
        reader.onload = function () {
          console.log(JSON.parse(reader.result));
        }
        reader.readAsText(error.response.data);

        reject(error.response)
      } else reject(error)

    });

  })
}

const doPostMultipart = (context, url, formData, cbResolve) => {
  const headers = {
    ...util.getAuthHeader(),
    'Content-Type': 'multipart/form-data'
  };

  return new Promise((resolve, reject) => {
    context.axios.post(url, formData, { headers })
      .then(response => {
        if (cbResolve) cbResolve();
        resolve(response.data);
      })
      .catch(error => {
        if (error.response) {
          util.showDialogError(context, error.response.data.message);
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};

const doPut = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.put(url, body, {headers}).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });
  })
}


const doPatch = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.patch(url, body, {headers}).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });
  })
}


const doDelete = (context, url, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.delete(url, {headers}).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });
  })
}

export default {
  doGet,
  doPost,
  doPostDonwload,
  doPostMultipart,
  doPut,
  doPatch,
  doDelete
};



// WEBPACK FOOTER //
// ./src/api/methods.js